import { render, staticRenderFns } from "./TwitterLogin.vue?vue&type=template&id=3f31e1b4&scoped=true"
import script from "./TwitterLogin.vue?vue&type=script&lang=js"
export * from "./TwitterLogin.vue?vue&type=script&lang=js"
import style0 from "./TwitterLogin.vue?vue&type=style&index=0&id=3f31e1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31e1b4",
  null
  
)

export default component.exports